module.exports = __webpack_public_path__ + "img/mobile_map_calderaradireno.bc338e40.png";